import React, { ReactElement } from 'react';
import CardContentInternal from '@mui/material/CardContent';
import FormatService from '../../services/format-service';
import useStylesCardContent from './card-content.styles';

const CardContent: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    className,
    children,
  } = props;

  const { classes } = useStylesCardContent();

  return (
    <CardContentInternal className={FormatService.formatClassNames(classes.cardContent, className)}>
      {children}
    </CardContentInternal>
  );
});

export default CardContent;
